module.exports = __webpack_public_path__ + "media/images/flags/do-164feaa1f07e28af064ba4f8d1d8c930.svg";